import { createContext, useContext } from "react";
import { useAccountingHospital } from "@/hooks/useAccountingHospital";

type Ctx = ReturnType<typeof useAccountingHospital>;

const AccountingHospitalContext = createContext<Ctx | null>(null);

export function AccountingHospitalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useAccountingHospital();
  return (
    <AccountingHospitalContext.Provider value={value}>
      {children}
    </AccountingHospitalContext.Provider>
  );
}

export function useAccountingHospitalContext() {
  const ctx = useContext(AccountingHospitalContext);
  if (!ctx) {
    throw new Error("useAccountingHospitalContext must be used within AccountingHospitalProvider");
  }
  return ctx;
}
